/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SortLabelsRequestLabelsInner
 */
export interface SortLabelsRequestLabelsInner {
  /**
   *
   * @type {string}
   * @memberof SortLabelsRequestLabelsInner
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof SortLabelsRequestLabelsInner
   */
  sort: number
}

export function SortLabelsRequestLabelsInnerFromJSON(json: any): SortLabelsRequestLabelsInner {
  return SortLabelsRequestLabelsInnerFromJSONTyped(json, false)
}

export function SortLabelsRequestLabelsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SortLabelsRequestLabelsInner {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    sort: json['sort']
  }
}

export function SortLabelsRequestLabelsInnerToJSON(value?: SortLabelsRequestLabelsInner | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    sort: value.sort
  }
}
